module.exports = __webpack_public_path__ + "assets/images/10L.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10L.png
// module id = 1285
// module chunks = 1